export default "__VITE_ASSET__CaLMotRY__"